import { graphql } from '~/gql'

const BROADBAND_AND_TV_DEALS_QUERY = graphql(`
  query broadbandAndTvDealsQuery($broadbandTVSlug: String, $broadbandTVFilters: Filters, $limit: Int) {
    broadbandTVDealsFeed: dealsFeed(slug: $broadbandTVSlug, filters: $broadbandTVFilters, limit: $limit) {
      deals {
        ...dealFields
      }
    }
    broadbandTVDealsCount: dealsFeed(slug: $broadbandTVSlug, filters: $broadbandTVFilters) {
      count
    }
  }
`)

export default BROADBAND_AND_TV_DEALS_QUERY
